import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { KpiAdminManagementService } from '../../../../../../../services/kpiadminmanagement.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-kpistageresults-historydialog',
    templateUrl: './kpistageresults-historydialog.component.html',
    styleUrls: ['./kpistageresults-historydialog.component.less',
        '../../../../../../../style/changelog-dialog/changelog-dialog.less'],
    standalone: false
})

export class KpiStageResultsHistoryPopup implements OnInit {

    public dataSource = new MatTableDataSource<KpiStageResultsChanges>();
    searchString: string = '';
    targetWaveId: string = '';
    originalData: KpiAccountChanges[] = [];
    @ViewChild(MatSort) matSort = new MatSort();
    @ViewChild('tableBody') tableBody!: ElementRef;
    isOpenTextAreaOverlay: boolean = false;

    constructor(
        private kpiAdminService: KpiAdminManagementService,
        private dialogRef: MatDialogRef<KpiStageResultsHistoryPopup>,
        @Inject('BASE_URL') private baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public datePipe: DatePipe,
        private toast: ToastrService) { }

    columnsToDisplay = ["date", "upn", "details"];

    ngOnInit(): void {
        this.searchString = '';
        this.originalData = [];

        this.kpiAdminService.getKpiStageResultsHistory(
            this.data.WaveId,
            (response: KpiStageResultshistory) => {
                if (response) {
                    this.tableBody.nativeElement.style.visibility = "visible";
                    this.targetWaveId = response.targetWaveId;
                    this.dataSource.data = response.changesList;
                    this.originalData = response.changesList;
                }
            },
            error => {
                this.toast.error('Unable to load KPI account history.');
                this.tableBody.nativeElement.style.visibility = "hidden";
            }
        );
    }

    async updateFilteredHistory() {
        this.dataSource.data = this.filterAndShowResults(this.searchString);
    }

    filterAndShowResults(searchString: string) {
        // If the search string is empty, show all items
        if (searchString === "") {
            return this.originalData;
        }
        return this.originalData.filter(item => searchString === "" ? true : item.upn.toLowerCase().includes(searchString.toLowerCase())
            || item.details.toLowerCase().includes(searchString.toLowerCase()));
    }

    close() {
        this.dialogRef.close();
    }
}